import * as React from "react";
import { HelmetDexteel } from "../../../helmet/HelmetDexteel";
import { TableQueryCache } from "./components/QueryCacheTable/TableQueryCache";

export const QueryCache = () => {
	return (
		<>
			<HelmetDexteel title="Query Cache Config" />
			<TableQueryCache />
		</>
	);
};
